import { SxProps, Theme } from '@mui/material';

export const titleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
	fontWeight: 'bold',
	color: '#333333',
	letterSpacing: '0px',
};

export const subtitleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
	fontWeight: 'normal',
	color: '#2C2C2C',
	letterSpacing: '0px',
	padding: '0px',
	marginLeft: '2px',
};

export const containerNextSX: SxProps<Theme> = (theme) => ({
	borderRadius: '4px',
	flexDirection: 'column',
	marginBottom: '5px',
	border: '1px solid #E8E8E8',
	padding: '14px',
	width: '50%',
	[theme.breakpoints.down('md')]: {
		width: '100%',
	},
});

export const containerTitleNextSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	'& > :first-child': {
		marginRight: '5px',
		width: '19px',
	},
};

export const listItemSX: SxProps<Theme> = {
	padding: 0,
	display: 'flex',
	alignItems: 'center',
	'&::before': {
		content: '""',
		display: 'inline-block',
		width: '2px',
		height: '2px',
		borderRadius: '50%',
		backgroundColor: '#2C2C2C',
		marginRight: '8px',
	},
};
